import { Controller } from 'react-hook-form'

import { AutoCompleteSelect, AutoCompleteSelectProps } from '../../../antd'

const Select = (props: AutoCompleteSelectProps) => {
  const { control, name, required, defaultValue } = props
  return (
    <Controller
      name={name}
      control={control}
      defaultValue={defaultValue}
      rules={{ required }}
      render={({ value, onChange: controllerOnChange }) => {
        const onChange = (newValue: any) => {
          controllerOnChange?.(newValue || null)
        }
        return <AutoCompleteSelect {...props} value={value} onChange={onChange} />
      }}
    />
  )
}

export default Select
